<div class="container-fluid text-center flex-column" >
  <form class="form-signin shadow p-3 mb-5 bg-white rounded" [formGroup]="loginForm" (ngSubmit)="submitLogin()">
    <img routerLink="/" class="mb-4" src="https://cdn.iconscout.com/icon/free/png-512/koala-bear-lazy-honey-wild-animal-33903.png" width="60" height="60" alt="">
    <h1 class="h3 mb-3 font-weight-normal">Inicio de sesión</h1>
    <label for="inputEmail" class="sr-only">Email</label>
    <input type="email" id="inputEmail" class="form-control mb-3" placeholder="Email" formControlName="email" required autofocus>
    <label for="inputPassword" class="sr-only">Contraseña</label>
    <input type="password" id="inputPassword" class="form-control mb-3" placeholder="Contraseña" formControlName="password" required>
    <!-- TEXTO FORGOT PASSWORD
      <a class="forgotpassword" routerLink="/remind-password">Forgot password?</a> -->
    <!-- CHECKBOX REMEMBER-ME
       <div class="checkbox mb-3">
      <label>
        <input type="checkbox" value="remember-me"> Remember me
      </label>
    </div> -->
    <div *ngIf="errorLog" class="alert alert-danger" role="alert"> 
      Debes introducir un correo y una contraseña validos
    </div>
    <button type="submit" class="btn btn-outline-success  my-2 my-sm-0">Iniciar sesión</button>
    
    <div class="or-container">
      <div class="line-separator"></div>
      <div class="or-label">or</div>
      <div class="line-separator"></div>
  </div>
  <a  class="btn btn-outline-light my-2 my-sm-0" style="color:green;border-width: 1px; border-color: green ;" href="https://karmic-koala-backend.vercel.app/auth/google/login" ><img src="https://img.icons8.com/color/16/000000/google-logo.png"> Sign in with Google</a>
</form>
<p> ¿No tienes cuenta?
  <a href="/register"> Registrate </a>
</p>
</div>